import { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { useLogout } from "../api/useLogout";

import { ROUTES } from "@/constants/routes";

function SignOutPage() {
  const logout = useLogout();

  useEffect(() => {
    logout();
  }, [logout]);

  return <Navigate to={ROUTES.login} />;
}

export default SignOutPage;
